import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import React, { useState } from 'react';
import affiliateDashboard from '../../assets/images/tapfiliate-reporting.png';

// accordionData.js
export const accordionData = [
  {
    title: 'How do I join the My Code Dragon Affiliate Program?',
    content: `
      <ul class="list-disc pl-6">
        <li>Simply fill out our online Affiliate Application on our website.</li>
        <li>Once submitted, you'll receive instructions to complete the setup steps.</li>
      </ul>
    `,
  },
  {
    title: 'Who is eligible to become an affiliate?',
    content: `
      <ul class="list-disc pl-6">
        <li>Our program is open to individuals, bloggers, educators, and organizations passionate about empowering young coders.</li>
        <li>You must be 18 years or older and have an active online presence (website, blog, or social media platform).</li>
        <li>Please note: Only United States citizens are eligible to participate at this time.</li>
      </ul>
    `,
  },
  {
    title: 'What are the required steps to get started?',
    content: `
      <ol class="list-decimal pl-6">
        <li>Complete the Affiliate Application.</li>
        <li>Set up your payout method in our secure portal.</li>
        <li>Submit your W-9 form for tax purposes.</li>
        <li>Enjoy 6 months of free access to My Code Dragon to explore and create content.</li>
        <li>Log into your Tapafiliate dashboard to access your unique affiliate URL and marketing assets.</li>
      </ol>
    `,
  },
  {
    title: 'What commission do affiliates earn?',
    content: `
      <ul class="list-disc pl-6">
        <li>Affiliates earn a 10% commission on every initial subscription sale made through your unique affiliate link.</li>
      </ul>
    `,
  },
  {
    title: 'How do I track my performance?',
    content: `
      <ul class="list-disc pl-6">
        <li>Once you sign up, you'll have access to the Tapafiliate dashboard, where you can monitor clicks, conversions, and commission earnings in real time.</li>
      </ul>
    `,
  },
  {
    title: 'What marketing materials will I receive?',
    content: `
      <ul class="list-disc pl-6">
        <li>You'll have access to My Code Dragon's logo, and pre-made marketing content in the Assets section of your Tapafiliate account.</li>
        <li>These materials are designed to help you create engaging content that drives conversions.</li>
      </ul>
    `,
  },
  {
    title: 'How often are commission payments made?',
    content: `
      <ul class="list-disc pl-6">
        <li><strong>Payout Timing:</strong> Commissions are processed 30 days after a qualifying purchase to allow for refunds or chargebacks.</li>
        <li><strong>Eligibility:</strong> Payouts occur only after this 30-day period and if your commission balance is at least $50 (balances below roll over).</li>
        <li><strong>Refunds:</strong> If a transaction is refunded or reversed within 30 days, the commission is voided.</li>
      </ul>
    `,
  },
  {
    title: 'Can I offer special discounts to my audience?',
    content: `
      <ul class="list-disc pl-6">
        <li>Yes! You can promote our ongoing 10% discount for annual subscriptions by sharing our promo code with your audience. You can find the promo code in the Assets section of the My Code Dragon's Tapfiliate account.</li>
      </ul>
    `,
  },
  {
    title: 'Who do I contact if I have questions or need support?',
    content: `
      <ul class="list-disc pl-6">
        <li>Our affiliate support team is here to help! You can email us at <a href="mailto:info@MyCodeDragon.com" class="text-blue-600">info@MyCodeDragon.com</a> for any questions or assistance.</li>
      </ul>
    `,
  },
];

const stepsData = {
  steps: [
    {
      stepNumber: 1,
      title: 'Complete Your Affiliate Application',
      description:
        "Sign up to join the My Code Dragon Affiliate Program and tell us why you're excited to help empower young coders.",
      items: [],
      link: {
        text: 'Apply to our Affiliate Program',
        url: '/affiliate-form',
      },
    },
    {
      stepNumber: 2,
      title: 'Set Up Your Payout Method',
      description:
        'Securely add your PayPal payment details so you can receive commissions promptly.',
      items: [],
    },
    {
      stepNumber: 3,
      title: 'Submit Your W-9 Form',
      description:
        'Provide your tax information to help us stay compliant with IRS regulations.',
      items: [],
    },
    {
      stepNumber: 4,
      title: 'Enjoy 6 Months Free Access',
      description:
        'Explore My Code Dragon, create content, and experience our AI-powered coding platform firsthand.',
      items: [],
    },
    {
      stepNumber: 5,
      title: 'Access Your Affiliate Dashboard',
      description: (
        <>
          Track the effectiveness of your campaigns by leveraging your
          complimentary My Code Dragon Tapfiliate account. Affiliate reporting
          on sub_ids is intended to work on the affiliate's end and help them
          track their campaigns/sources.
          <br />
          <br />
          This is useful in a variety of settings. For example, affiliates can
          set a different source for each of these instances:
          <br />
          <br />
          <ol className="list-decimal pl-6">
            <li>To track traffic from a specific blog post or video</li>
            <li>
              To assess the traffic coming from a specific social media platform
            </li>
            <li>To analyze the placement of multiple links</li>
            <li>
              To see if your reviews containing referral links gain traction
            </li>
            <li>A/B testing</li>
          </ol>
          <br />
          How it works:
          <br />
          <br />
          Affiliates create a new Source in their affiliate portal. Then they
          can give it a name and the source type. When an affiliate wants to
          share a link with a source attached (to see how good a specific one
          performs), they can also attach sub_ids to the created link to add
          more information to their data recordings. For example, a default link
          is yourwebsite.com?ref=ghfdkek. A tap_s parameter will be added to the
          string when a source is attached, like
          yourwebsite.com?ref=ghfdkek&tap_s=467384949974_36464894. If the sub_id
          is added, it will also complete the link with a respective sub_id
          parameter:
          yourwebsite.com?ref=ghfdkek&tap_s=467384949974_36464894&tm_key1=value2&tem_key2=value3,
          where tm_key1 and tm_key2 will be the sub_ids.
          <br />
          <br />
          Once created, affiliates can use the generated links in their promo
          campaigns and check the numbers per source/sub_id in the affiliate
          Reporting section. As we can conclude from the screenshot below, the
          link with a sub_id main attached got 4 clicks so far, while the link
          with the sub_id must haves article brought 7 clicks, so the affiliate
          can see which specific links bring better results.
        </>
      ),
      items: [],
      image: affiliateDashboard,
    },
    {
      stepNumber: 6,
      title: 'Earn 10% Commission',
      description:
        'Every new subscription purchased via your affiliate link earns you a 10% commission - grow your earnings as you help spread the love of coding!',
      items: [],
    },
  ],
};

const Steps = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <div className="container py-5 md:py-10 px-4 md:px-6">
        {stepsData.steps.map((step) => (
          <div
            key={step.stepNumber}
            style={{
              background:
                step.stepNumber % 2 !== 0
                  ? 'linear-gradient(to right, rgba(100, 112, 255, 0.8), rgba(252, 252, 252, 0.8))'
                  : '#ffffff', // alternating between gradient and white
            }}
          >
            <div className="mb-6 md:mb-8 p-4 md:p-6 md:px-8 lg:px-16 xl:px-32 gap-4 md:gap-8 lg:gap-12 rounded-md flex flex-col md:flex-row">
              <div
                className={`leading-normal font-nunito text-center md:text-left ${step.stepNumber % 2 !== 0 ? 'text-white' : 'text-[#0a165b]'}`}
              >
                <h2 className="text-3xl md:text-4xl lg:text-[48px] font-bold">
                  Step #{step.stepNumber}
                </h2>
                <h3 className="text-2xl md:text-3xl lg:text-[36px] md:w-auto lg:w-[350px] font-semibold mt-2">
                  {step.title}
                </h3>
              </div>
              <div className="px-0 md:px-6 lg:px-12 text-[#0a165b]">
                <p className="text-lg md:text-xl mt-2 font-nunito text-center md:text-left">
                  {typeof step.description === 'string' &&
                  step.description.includes('educative.io') ? (
                    <>
                      Make sure to create a free account on{' '}
                      <span className="text-blue-600">educative.io</span> before
                      you start the application
                    </>
                  ) : (
                    step.description
                  )}
                </p>

                {step.link && (
                  <div className="mt-4 text-center md:text-left">
                    <a
                      href={step.link.url}
                      className="bg-[#0a165b] text-white py-2 px-4 md:py-3 md:px-6 rounded-lg inline-block font-semibold hover:bg-[#152a7c] transition-colors"
                    >
                      {step.link.text}
                    </a>
                  </div>
                )}
              </div>
            </div>

            {/* Add image at the bottom if it exists */}
            {step.image && (
              <div className="w-full p-4 md:pt-6 col-span-full">
                <img
                  src={step.image}
                  alt={`Step ${step.stepNumber} - ${step.title}`}
                  className="w-full rounded-md shadow-md"
                />
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="max-w-5xl mx-auto mt-8 px-4 md:px-6">
        <h2 className="text-3xl text-[#0A165B] font-nunito font-bold mb-8 text-center text-navy-900">
          FAQs
        </h2>

        {accordionData.map((item, index) => (
          <div key={index} className="border-b border-gray-300 mb-4">
            <button
              onClick={() => toggleAccordion(index)}
              className="w-full flex items-center justify-between p-3 md:p-5 bg-gradient-to-r from-blue-500 to-teal-500 text-white font-semibold rounded-lg hover:bg-gradient-to-l transition-colors"
            >
              <div className="flex items-center space-x-3">
                <span className="text-base md:text-lg">{item.title}</span>
              </div>
              {activeIndex === index ? (
                <ChevronUpIcon className="w-5 h-5 md:w-6 md:h-6" />
              ) : (
                <ChevronDownIcon className="w-5 h-5 md:w-6 md:h-6" />
              )}
            </button>

            {activeIndex === index && (
              <div className="p-3 md:p-5 bg-white text-gray-700 border-t-2 border-gray-200 rounded-b-lg shadow-md">
                <div
                  dangerouslySetInnerHTML={{ __html: item.content }}
                  className="space-y-4 text-sm md:text-base"
                />
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mb-8 p-4 md:p-6 md:px-16 lg:px-32 gap-4 md:gap-12 rounded-md flex flex-col text-[#0a165b] text-sm md:text-base">
        <p className="mt-4">
          <strong>Disclaimer:</strong> This Affiliate Program Agreement is a
          template and should be reviewed by a legal professional to ensure
          compliance with all applicable laws and regulations. MyCodeDragon
          reserves the right to modify these terms at any time. For complete
          terms and conditions, please review our{' '}
          <a
            href="/affiliate-terms"
            className="text-blue-600 underline hover:text-blue-800"
          >
            Affiliate Terms and Conditions
          </a>
          .
        </p>
        <p className="mt-4">
          <strong>Acknowledgment:</strong> By submitting an application to join
          the Affiliate Program, you acknowledge that you have read this
          Agreement, understand it, and agree to be bound by its terms and
          conditions.
        </p>
      </div>
    </>
  );
};

export default Steps;
